<template>
  <div>
    <div class="comp-content" :class="`comp-content--${source}`">
      <div class="info-area">
        <div class="left">
          <div class="row-company">
            <!-- <div class="logo">
              <img
                class="image"
                :src="
                  detail.comLogoBase64 || require('@/images/shippingLogo.png')
                "
              />
            </div> -->
            <div class="name-panel">
              <div class="cn">{{ PureFunc.strNull(detail.companyName) }}</div>
              <div class="en">{{ PureFunc.strNull(detail.companyNameEn) }}</div>
            </div>
          </div>
          <div class="row-line">
            <div class="theme-line"></div>
          </div>
          <div class="row-info">
            <div class="item">
              {{
                lclTools.quoDetailPort2Port(detail, this.$i18n.locale).showStr
              }}
            </div>
            <div class="item">
              <div class="item-li" v-if="detail.shippingCodeStr">
                {{ $t("message.lclAdd.chuangongsi") }}:
                {{ detail.shippingCodeStr }};
              </div>
              <div class="item-li">
                <!-- 中转直达信息 -->
                {{
                  lclTools.allProcessDetail(detail, $i18n.locale).inDetail
                    .joinShow
                }};
              </div>
            </div>
            <div class="item">
              <div class="item-li" v-if="detail.schedule">
                {{ $t("message.lclFreightList.banqi") }}: {{ detail.schedule }};
              </div>
              <div class="item-li" v-if="detail.cutoffDayName">
                {{ $t("message.lclAdd.jieguanqi") }}:
                {{ detail.cutoffDayName }};
              </div>
              <div class="item-li" v-if="detail.cutoffCargoName">
                {{ $t("message.lclAdd.jiedan") }}: {{ detail.cutoffCargoName }};
              </div>
              <div class="item-li" v-if="detail.cutGoodsName">
                {{ $t("message.lclAdd.jiehuo") }}: {{ detail.cutGoodsName }};
              </div>
            </div>
            <!-- 我的报价单来源 -->
            <div class="item">
              <div class="item-li">
                {{ $t("message.lcl.kehuleixing") }}:

                {{
                  lclTools.showCustomerTypeName(
                    quotationManager.calcForm.customerType,
                    $i18n.locale
                  )
                }}
              </div>
              <div class="item-li">
                {{ $t("message.lclAdd.huowuxinxi") }}:
                {{ quotationManager.calcForm.number
                }}{{
                  $byKey(
                    packageTypeOptions,
                    +quotationManager.calcForm.firstCalculateFlag
                  ).name
                }}
                / {{ quotationManager.calcForm.grossWeight }}KGS /
                {{ quotationManager.calcForm.volume }}CBM;
              </div>
            </div>
            <!-- <div
              class="item"
              v-if="lclTools.getWarehouseShow(detail, $i18n.locale)"
            >
              {{ $t("message.lclAdd.jiehuocangku") }}:
              {{ lclTools.getWarehouseShow(detail, $i18n.locale) }};
            </div> -->
            <div class="item">
              <WarehouseTextList :detail="detail"></WarehouseTextList>
            </div>

            <div class="item">
              {{ $t("message.lcl.youxiaoqi") }}:{{
                detail.beginDate | stamp2DayStr | date2Slash
              }}{{ $i18n.locale === "cn" ? "至" : "-"
              }}{{ detail.endDate | stamp2DayStr | date2Slash }}
            </div>
          </div>
        </div>
        <div class="right">
          <div class="sale-panel">
            <div class="code">
              <div class="line-1">
                {{ $t("message.ratePage.baojiabianhao") }}
              </div>
              <div class="line-2">{{ quotationNo }}</div>
            </div>
            <div
              class="show-list"
              :class="$i18n.locale === 'cn' ? '' : 'show-list--en'"
            >
              <div class="item">
                <div class="item-label">
                  {{ $t("message.ratePage.lianxiren") }}:
                </div>
                <div class="item-value">
                  {{
                    $str(
                      PureFunc.strNull(
                        detail.kfName
                     ),
                      "-"
                    )
                  }}
                </div>
              </div>
              <div class="item">
                <div class="item-label">
                  {{ $t("message.common.dianhua") }}:
                </div>
                <div class="item-value">
                  {{ $str(PureFunc.strNull(detail.kfTel), "-") }}
                </div>
              </div>
              <div class="item">
                <div class="item-label">{{ $t("message.common.email") }}:</div>
                <div class="item-value">
                  <div class="slh_two">
                    {{ $str(PureFunc.strNull(detail.kfEmail), "-") }}
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="item-label">
                  {{ $t("message.ratePage.shijian") }}:
                </div>
                <div class="item-value" v-if="detail.quotationTime">
                  {{ detail.quotationTime | stamp2MStr }}
                </div>
                <div class="item-value" v-else>
                  {{ dateStr }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line-area">
        <div class="row-line">
          <div class="theme-line"></div>
        </div>
      </div>
      <!-- 海运 -->
      <div class="table-list-area">
        <div class="row-1">
          <div class="col-1">{{ $t("message.lcl.haiyunjifujiafei") }}</div>
          <div class="col-2">
            <div
              class="total-obversion-area"
              v-if="quotationManager.oceanTotal.totalPriceList.length > 0"
            >
              <div class="li-area">
                <div class="li-title">{{ $t("message.lcl.heji") }}:</div>
                <div class="li-content">
                  <span
                    v-html="
                      quotationManager.priceRichStr(
                        quotationManager.oceanTotal.totalPriceList,
                        { neg: true }
                      )
                    "
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row-2">
          <div class="col-table">
            <div class="table-header">
              <div class="tr">
                <div class="th th1">#</div>
                <div class="th th2">
                  {{ $t("message.lcl.feiyongmingcheng") }}
                </div>
                <div class="th th3">{{ $t("message.lcl.bizhongjianxie") }}</div>
                <div class="th th4">{{ $t("message.lcl.danjia") }}</div>
                <div class="th th5">{{ $t("message.ratePage.shuliang") }}</div>
                <div class="th th6">{{ $t("message.lcl.jine") }}</div>
                <div class="th th7">{{ $t("message.common.beizhu") }}</div>
              </div>
            </div>
            <div class="table-body">
              <div
                class="tr"
                v-for="(item, index) in quotationManager.oceanChargeList"
                :key="index"
              >
                <div class="td td1">{{ index + 1 }}</div>
                <div class="td td2">
                  {{
                    lclTools.showChargeNameCnEn(
                      item.data,
                      "chargeName",
                      "chargeCode"
                    ) | strLine
                  }}
                </div>
                <div class="td td3">
                  {{ $str(item.data.currencyCode, "-", "${}") }}
                </div>
                <div class="td td4">
                  {{
                    lclTools.priceJoinUnit(
                      item.data,
                      (pk = "quoteUnitPrice"),
                      (uk = "unitName"),
                      { neg: true }
                    ) || "-"
                  }}
                </div>
                <div class="td td5">
                  {{ $str(item.data.number, "-", "${}") }}
                </div>
                <div class="td td6">
                  {{ $str(negativeFormat(item.data.finalPrice), "-", "${}") }}
                </div>
                <div class="td td7">
                  <template v-if="item.data.payType === 0">
                    <template v-if="!item.isSecond">
                      {{ $str(detail.cbmKgsRatio, "", "1:${};") }}
                      {{
                        $i18n.locale == "cn"
                          ? $byKey(payTypeOptions, detail.payFlag).name
                          : $byKey(payTypeOptions, detail.payFlag).nameEn
                      }};
                      {{ $str(detail.minPrice, "", "${}RT") }}
                    </template>
                    <template v-if="item.isSecond">
                      {{ $str(detail.ltCbmKgsRatio, "", "1:${};") }}
                      {{
                        $i18n.locale == "cn"
                          ? $byKey(payTypeOptions, detail.ltPayFlag).name
                          : $byKey(payTypeOptions, detail.ltPayFlag).nameEn
                      }};
                      <template v-if="!$isInputEmpty(detail.ltMinAmount)">
                        {{
                          $str(
                            detail.ltMinAmount,
                            "",
                            detail.ltCurrencyName + " ${}"
                          )
                        }}
                      </template>
                      <template v-else-if="!$isInputEmpty(detail.ltMinPrice)">
                        {{ $str(detail.ltMinPrice, "", "${} RT") }}
                      </template>
                    </template>
                  </template>
                  <template v-if="item.data.payType === 4">
                    {{ $str(detail.forwardCbmKgsRatio, "", "1:${};") }}
                    {{
                      $i18n.locale == "cn"
                        ? $byKey(payTypeOptions, 1).name
                        : $byKey(payTypeOptions, 1).nameEn
                    }};
                    <template v-if="!$isInputEmpty(detail.forwardMinPrice)">
                      {{
                        $str(
                          detail.forwardMinPrice,
                          "",
                          detail.forwardCurrencyName + " ${}"
                        )
                      }}
                    </template>
                    <template v-else-if="!$isInputEmpty(detail.forwardMinRt)">
                      {{ $str(detail.forwardMinRt, "", "${} RT") }}
                    </template>
                  </template>

                  <template v-if="item.data.payType === 3">
                    {{ item.data.description | strLine }}
                  </template>
                </div>
              </div>
            </div>
            <div
              class="table-remark"
              style="display: grid; grid-template-columns: 1fr; row-gap: 8px"
              v-if="
                quotationManager.quotationForm.description ||
                detail.portTransaction
              "
            >
              <div v-if="detail.portTransaction">
                <div class="remark-title">
                  {{ $t("message.lcl.gangkoushixiang") }}
                </div>
                <div class="remark-content">
                  {{ $str(detail.portTransaction) }}
                </div>
              </div>
              <div v-if="quotationManager.quotationForm.description">
                <div class="remark-title">
                  {{ $t("message.common.beizhuxinxi") }}
                </div>
                <div class="remark-content">
                  {{ quotationManager.quotationForm.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 起运港 -->
      <div
        class="table-list-area"
        v-if="
          (quotationManager.startChargeList &&
            quotationManager.startChargeList.length > 0) ||
          quotationManager.quotationForm.startRemark
        "
      >
        <div class="row-1">
          <div class="col-1">{{ $t("message.lcl.qiyungangfeiyong") }}</div>
          <div class="col-2">
            <div
              class="total-obversion-area"
              v-if="quotationManager.startTotal.totalPriceList.length > 0"
            >
              <div class="li-area">
                <div class="li-title">{{ $t("message.lcl.heji") }}:</div>
                <div class="li-content">
                  <span
                    v-html="
                      quotationManager.priceRichStr(
                        quotationManager.startTotal.totalPriceList
                      )
                    "
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row-2">
          <div class="col-table">
            <div class="table-header">
              <div class="tr">
                <div class="th th1">#</div>
                <div class="th th2">
                  {{ $t("message.lcl.feiyongmingcheng") }}
                </div>
                <div class="th th3">{{ $t("message.lcl.bizhongjianxie") }}</div>
                <div class="th th4">{{ $t("message.lcl.danjia") }}</div>
                <div class="th th5">{{ $t("message.ratePage.shuliang") }}</div>
                <div class="th th6">{{ $t("message.lcl.jine") }}</div>
                <div class="th th7">{{ $t("message.common.beizhu") }}</div>
              </div>
            </div>
            <div
              class="table-body"
              v-if="
                quotationManager.startChargeList &&
                quotationManager.startChargeList.length > 0
              "
            >
              <div
                class="tr"
                v-for="(item, index) in quotationManager.startChargeList"
                :key="index"
              >
                <div class="td td1">{{ index + 1 }}</div>
                <div class="td td2">
                  {{
                    lclTools.showChargeNameCnEn(
                      item.data,
                      "chargeName",
                      "chargeCode"
                    ) | strLine
                  }}
                </div>
                <div class="td td3">
                  {{ $str(item.data.currencyCode, "-", "${}") }}
                </div>
                <div class="td td4">
                  {{
                    lclTools.priceJoinUnit(
                      item.data,
                      (pk = "quoteUnitPrice"),
                      (uk = "unitName")
                    ) || "-"
                  }}
                </div>
                <div class="td td5">
                  {{ $str(item.data.number, "-", "${}") }}
                </div>
                <div class="td td6">
                  {{ $str(item.data.finalPrice, "-", "${}") }}
                </div>
                <div class="td td7">{{ item.data.description | strLine }}</div>
              </div>
            </div>
            <div class="table-body-empty" v-else>
              <div class="tr-empty">CASE BY CASE</div>
            </div>
            <div
              class="table-remark"
              v-if="quotationManager.quotationForm.startRemark"
            >
              <div class="remark-title">
                {{ $t("message.common.beizhuxinxi") }}
              </div>
              <div class="remark-content">
                {{ quotationManager.quotationForm.startRemark }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 目的港 -->
      <div
        class="table-list-area"
        v-if="
          (quotationManager.endChargeList &&
            quotationManager.endChargeList.length > 0) ||
          quotationManager.quotationForm.endRemark
        "
      >
        <div class="row-1">
          <div class="col-1">{{ $t("message.lcl.mudigangfeiyong") }}</div>
          <div class="col-2">
            <div class="total-obversion-area">
              <div
                class="li-area"
                v-if="quotationManager.endTotal.totalPriceList.length > 0"
              >
                <div class="li-title">{{ $t("message.lcl.heji") }}:</div>
                <div class="li-content">
                  <span
                    v-html="
                      quotationManager.priceRichStr(
                        quotationManager.endTotal.totalPriceList
                      )
                    "
                  ></span>
                </div>
              </div>
              <div
                class="li-area"
                v-if="
                  quotationManager.endTotal.convertTotalPriceList.length > 0
                "
              >
                <div class="li-title">{{ $t("message.lcl.zhesuan") }}</div>
                <div class="li-content">
                  <span
                    v-html="
                      quotationManager.priceRichStr(
                        quotationManager.endTotal.convertTotalPriceList
                      )
                    "
                  ></span>
                </div>
              </div>
              <div
                class="li-area"
                v-if="
                  !$isInputEmpty(quotationManager.getEndSurchargeMinPrice())
                "
              >
                <div class="li-title">{{ $t("message.lcl.zuidishoufei") }}</div>
                <div class="li-content">
                  <span>{{ quotationManager.getEndSurchargeMinPrice() }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ExchangeRateShow" v-if="quotationManager.rateArr">
          <ExchangeRateShow
            :text="quotationManager.formatRateShowStrForComputed()"
          ></ExchangeRateShow>
        </div>
        <div class="row-2">
          <div class="col-table">
            <div class="table-header">
              <div class="tr">
                <div class="th th1">#</div>
                <div class="th th2">
                  {{ $t("message.lcl.feiyongmingcheng") }}
                </div>
                <div class="th th3">{{ $t("message.lcl.bizhongjianxie") }}</div>
                <div class="th th4">{{ $t("message.lcl.danjia") }}</div>
                <div class="th th5">{{ $t("message.ratePage.shuliang") }}</div>
                <div class="th th6">{{ $t("message.lcl.jine") }}</div>
                <div class="th th7">{{ $t("message.common.beizhu") }}</div>
              </div>
            </div>
            <div
              class="table-body"
              v-if="
                quotationManager.endChargeList &&
                quotationManager.endChargeList.length > 0
              "
            >
              <div
                class="tr"
                v-for="(item, index) in quotationManager.endChargeList"
                :key="index"
              >
                <div class="td td1">{{ index + 1 }}</div>
                <div class="td td2">
                  {{
                    lclTools.showChargeNameCnEn(
                      item.data,
                      "chargeName",
                      "chargeCode"
                    ) | strLine
                  }}
                </div>
                <div class="td td3">
                  {{ $str(item.data.currencyCode, "-", "${}") }}
                </div>
                <div class="td td4">
                  <span
                    v-if="
                      lclTools.showPercentageRule(
                        item.data,
                        'quoteUnitPrice',
                        'unitName'
                      )
                    "
                  >
                    {{
                      lclTools.showPercentageRule(
                        item.data,
                        "quoteUnitPrice",
                        "unitName"
                      )
                    }}
                  </span>
                  <span v-else>
                    {{
                      lclTools.priceJoinUnit(
                        item.data,
                        (pk = "quoteUnitPrice"),
                        (uk = "unitName")
                      ) || "-"
                    }}
                  </span>
                </div>
                <div class="td td5">
                  {{ $str(item.data.number, "-", "${}") }}
                </div>
                <div class="td td6">
                  {{ $str(item.data.finalPrice, "-", "${}") }}
                </div>
                <div class="td td7">{{ item.data.description | strLine }}</div>
              </div>
            </div>
            <div class="table-body-empty" v-else>
              <div class="tr-empty">CASE BY CASE</div>
            </div>
            <div
              class="table-remark"
              v-if="quotationManager.quotationForm.endRemark"
            >
              <div class="remark-title">
                {{ $t("message.common.beizhuxinxi") }}
              </div>
              <div class="remark-content">
                {{ quotationManager.quotationForm.endRemark }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tip-area">
        <ReferenceOnlyTip type="LclListQuotation"></ReferenceOnlyTip>
      </div>
    </div>
  </div>
</template>

<script>
import WarehouseTextList from "@/pages/lclFreightList/components/quotationComps/WarehouseTextList.vue";
import { negativeFormat, binary2Show } from "@/utils/tool";
import { mapState, mapGetters } from "vuex";
import * as lclTools from "@/pages/lclFreightList/lclTools.js";
import { DateTime } from "@/utils/DateTime";
import { packageTypeOptions } from "@/api/options/lcl";
import { PureFunc } from "@/pages/rates/QuotationDialog/tools";
import { payTypeOptions } from "@/api/options/lcl";
import ExchangeRateShow from "./LclQuotationDialog/components/ExchangeRateShow/index.vue";
export default {
  props: {
    saleData: {
      type: Object,
      default: () => ({}),
    },
    quotationManager: {
      type: Object,
      default: () => ({}),
    },
    detail: {
      type: Object,
      default: () => ({}),
    },

    quotationNo: {
      type: String,
      default: "",
    },
    source: {
      type: String,
      default: "", // quotationDetail  quotationEdit
    },
  },
  components: {
    ExchangeRateShow,
    WarehouseTextList,
  },
  computed: {
    ...mapState({

    }),
  },
  data() {
    return {
      payTypeOptions: payTypeOptions,
      lclTools,
      packageTypeOptions,
      dateStr: "",
      PureFunc,
    };
  },
  created() {
    this.dateStr = DateTime.formatToStr(new Date(), "YYYY-MM-DD HH:mm");
    console.log(this.detail);
  },
  mounted() {},
  methods: {
    negativeFormat,
    binary2Show,
  },
};
</script>

<style scoped lang="scss">
.comp-content {
  @mixin rowLineStyle {
    width: 100%;
    height: 1px;
    background: #ecf0f6;
    position: relative;
    .theme-line {
      width: 64px;
      height: 2px;
      background: var(--theme);
      border-radius: 1px;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .info-area {
    padding: 24px 24px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .left {
      width: 504px;
      overflow: hidden;
      .row-company {
        display: flex;
        align-items: center;
        .logo {
          flex: 0 0 auto;
          width: 64px;
          height: 64px;
          background: #ffffff;
          border: 1px solid #e4e7ee;
          box-shadow: -1px 6px 24px 0px rgba(1, 7, 24, 0.04);
          border-radius: 14px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          .image {
            display: block;
            width: 48px;
            height: 48px;
            object-fit: contain;
          }
        }
        .name-panel {
          // margin-left: 16px;
          flex: 1 1 auto;
          .cn {
            // 26 18 8
            width: 100%;
            font-size: 18px;
            font-weight: bold;
            color: #171920;
          }
          .en {
            // 20 14 3
            width: 100%;
            font-size: 14px;
            font-weight: 500;
            color: #61667c;
          }
        }
      }
      .row-line {
        @include rowLineStyle();
        margin-top: 24px;
      }
      .row-info {
        font-size: 13px;
        font-weight: bold;
        color: #323239;
        .item {
          margin-top: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          &:first-child {
            margin-top: 14px;
          }
          .item-li {
            margin-right: 6px;
          }
        }
      }
    }
    .right {
      width: 234px;
      background: #ffffff;
      border: 1px solid #ecf0f6;
      border-radius: 10px;
      overflow: hidden;
      .sale-panel {
        width: 100%;
        .code {
          width: 100%;
          height: 74px;
          background: var(--theme);
          border-radius: 10px 10px 0px 0px;
          font-size: 15px;
          font-weight: 500;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .line-1 {
            font-weight: bold;
          }
          .line-2 {
          }
        }
        .show-list {
          padding: 6px 12px 30px;
          .item {
            margin-top: 20px;
            font-size: 13px;
            color: #484851;
            display: flex;
            align-items: flex-start;
            overflow: hidden;
            font-weight: bold;
            .item-label {
              flex: 0 0 auto;
              line-height: 16px;
              white-space: nowrap;
              min-width: 44px;
            }
            .item-value {
              flex: 1 1 auto;
              line-height: 16px;
              word-break: break-all;
              overflow-wrap: break-word;
              // white-space: nowrap;
              // text-overflow: ellipsis;
              overflow: hidden;
              margin-left: 4px;
            }
            &:first-child {
              margin-top: 16px;
            }
          }
        }
        .show-list--en {
          .item {
            .item-label {
              min-width: 50px;
            }
          }
        }
      }
    }
  }
  .line-area {
    padding: 0 24px;
    margin-top: 30px;
    .row-line {
      @include rowLineStyle();
    }
  }
  .table-list-area {
    width: 100%;
    padding: 32px 24px 0;
    .row-1 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      // margin-bottom: 10px;
      .col-1 {
        font-size: 16px;
        font-weight: bold;
        color: #212529;
        line-height: 23px;
        margin-right: 5px;
        margin-bottom: 8px;
      }
      .col-2 {
        font-size: 13px;
        font-weight: bold;
        color: #f28900;
        line-height: 23px;
        margin-bottom: 8px;
        .total-obversion-area {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          .li-area {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            font-size: 13px;
            font-weight: bold;
            color: #f28900;
            margin-right: 12px;
            &:last-child {
              margin-right: 0px;
            }
            .li-title {
              margin-right: 6px;
              display: flex;
              flex: none;
            }
            .li-content {
              word-break: break-word;
              overflow-wrap: break-word;
              word-wrap: break-word;
              white-space: normal;
              /deep/.join {
                margin: 0 2px;
              }
            }
          }
        }
      }
    }
    .row-2 {
      $li1: 40px;
      $li2: 250px;
      $li3: 74px;
      $li4: 84px;
      $li5: 74px;
      $li6: 74px;
      $tableHeight: 30px;
      $borderColor: #e9f0f7;
      $padding: 10px;
      $tableBj: #f6f9fc;
      padding-top: 2px;
      .col-table {
        width: 100%;
        box-sizing: border-box;
        .table-header {
          .tr {
            display: grid;
            grid-template-columns: $li1 $li2 $li3 $li4 $li5 $li6 auto;
            .th {
              height: $tableHeight + 4px;
              font-size: 14px;
              font-weight: bold;
              color: #323239;
              line-height: $tableHeight + 4px;
              padding: 0 $padding;
            }
          }
        }
        .table-body {
          border: 1px solid $borderColor;
          .tr {
            display: grid;
            grid-template-columns: $li1 $li2 $li3 $li4 $li5 $li6 auto;
            border-bottom: 1px solid $borderColor;
            &:last-child {
              border-bottom: 0;
            }
            &:nth-child(even) {
              background: $tableBj;
            }
            .td {
              width: 100%;
              min-height: $tableHeight;
              font-size: 13px;
              font-weight: 500;
              color: #5d5d6a;
              padding: 5px $padding;
              border-right: 1px solid $borderColor;
              box-sizing: border-box;
              display: flex;
              align-items: center;

              word-break: break-word;
              overflow-wrap: break-word;
              word-wrap: break-word;
              white-space: normal;
              &:last-child {
                border-right: 0;
              }
            }
          }
        }
        .table-body-empty {
          width: 100%;
          height: 2 * $tableHeight;
          border: 1px solid $borderColor;
          display: flex;
          justify-content: center;
          align-items: center;
          .tr-empty {
            font-size: 13px;
            font-weight: 500;
            color: #5d5d6a;
          }
        }

        .table-remark {
          width: 100%;
          height: 100%;
          padding: 10px;
          background: $tableBj;
          // border-left: 1px solid $borderColor;
          // border-right: 1px solid $borderColor;
          // border-bottom: 1px solid $borderColor;
          border: 1px solid $borderColor;
          border-top: 0px;
          .remark-title {
            font-size: 13px;
            font-weight: bold;
            color: #484851;
            margin-bottom: 4px;
          }
          .remark-content {
            font-size: 13px;
            font-weight: 500;
            color: #5d5d6a;
            word-break: break-all;
            overflow-wrap: break-word;
          }
        }
      }
    }
    .ExchangeRateShow {
      margin-bottom: 14px;
    }
  }
  .tip-area {
    padding: 12px 24px 0;
  }
}
.comp-content--quotationDetail {
  .info-area {
    padding: 0px 24px 0;
  }
}
</style>
